export default "__VITE_ASSET__BEJYCg6$__"